import './_footer.scss'

const Footer = () => {
    return ( 
        <footer>
            <div className="container">
                <p className="copy">© 2026 New Wave - All rights reserved.</p>
            </div>
        </footer>
     )
}
 
export default Footer